import { useQuery } from '@tanstack/react-query';
import type { ApiResponse } from '@painter-crm/shared';
import { api } from './api';
import type { BusinessWorkItem } from './businessWorkItems';

export interface JarvisAttentionSummary {
  generatedAt: string;
  headline: string;
  counts: {
    openObligations: number;
    urgentObligations: number;
    highPriorityObligations: number;
    overdueObligations: number;
    activeJobs: number;
    sentEstimates: number;
    missingPreProductionSpecs: number;
    staleQuoteSessions: number;
    failedOutboundMessages: number;
    callsToday: number;
  };
  topObligations: BusinessWorkItem[];
  blockedAreas: Array<{
    key: string;
    label: string;
    count: number;
    severity: 'normal' | 'high' | 'urgent';
  }>;
  suggestedQuestions: string[];
}

export function useJarvisAttentionSummary() {
  return useQuery({
    queryKey: ['jarvis', 'attention-summary'],
    queryFn: async () => {
      const { data } = await api.get<ApiResponse<JarvisAttentionSummary>>('/api/v1/jarvis/attention-summary');
      return data.data;
    },
  });
}
